import React, { useEffect, useState, useCallback } from "react";
import CustomTable from "../../../components/Table/Table";
import EditPrimaryIcon from "../../../assets/icons/edit-icon-24px.svg";
import DeleteIcon from "../../../assets/icons/delete.svg";
import SearchBar from "../../../components/searchBar/searchBar";

import LinearProgress from "@mui/material/LinearProgress";
import InternetErrorComponent from "../../../components/Errors/InternetErrorComponent";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { getAllSalePoint } from "../../../services/utilsSalePoint";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";
import InputAdornment from "@mui/material/InputAdornment";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useHistory } from "react-router-dom";
import "./ScheduleListPage.scss";
import Typography from "@mui/material/Typography";
import { postScheduleProductAvailability, getProductAvailabilitySchedule, putScheduleProductAvailability, deleteScheduleProductAvailability } from "../../../services/utilsSchedule/utilsSchedule";

const ScheduleListPage = ({ showForm = false, toggleForm }) => {
  // ----------------------------------------------------
  // ------------- Variables & Constants ---------------- 
  // ----------------------------------------------------
  const [searchQuery, setSearchQuery] = useState("");

  const [productCategories, setProductCategories] = useState([]);

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [pagination, setPagination] = useState({});

  const [loading, setLoading] = useState(true);

  const [loadingError, setLoadingError] = useState(false);

  const [tableLoading, setTableLoading] = useState(true);

  const [savingSchedule, setSavingSchedule] = useState(false);

  // states for snackbar/toast
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const history = useHistory();

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffffff',
    boxShadow: 24,
    p: 2.5,
    borderRadius: 2,
  };

  // states for inline schedule form
  const [scheduleName, setScheduleName] = useState("");
  const [salePoints, setSalePoints] = useState([]);
  const [selectedSalePoints, setSelectedSalePoints] = useState([]);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");
  const [selectedDays, setSelectedDays] = useState({
    Lun: false,
    Mar: false,
    Mié: false,
    Jue: false,
    Vie: false,
    Sáb: false,
    Dom: false,
  });

  const [scheduleItems, setScheduleItems] = useState([
    {
      timeFrom: "",
      timeTo: "",
      selectedDays: {
        Lun: false,
        Mar: false,
        Mié: false,
        Jue: false,
        Vie: false,
        Sáb: false,
        Dom: false,
      }
    }
  ]);
  const handleAddScheduleItem = () => {
    setScheduleItems([
      ...scheduleItems,
      {
        timeFrom: "",
        timeTo: "",
        selectedDays: {
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        }
      }
    ]);
  };

  

  const timeToMinutes = (time) => {
    if (!time || time === '') return null;

    // Intentar formato completo HH:MM
    const fullTimeRegex = /^(\d{1,2}):(\d{2})$/;
    const fullMatch = time.match(fullTimeRegex);
    if (fullMatch) {
      const hours = parseInt(fullMatch[1]);
      const minutes = parseInt(fullMatch[2]);
      if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
        return hours * 60 + minutes;
      }
    }

    // Intentar formato parcial HH: o HH
    const partialTimeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const partialMatch = time.match(partialTimeRegex);
    if (partialMatch) {
      const hours = parseInt(partialMatch[1] || '0');
      const minutes = parseInt(partialMatch[2] || '0');
      if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
        return hours * 60 + minutes;
      }
    }

    return null;
  };

  const validateTimeRange = (timeFrom, timeTo) => {
    if (!timeFrom || !timeTo) return null; // No validar si alguno está vacío

    // Solo validar si ambos tienen formato completo HH:MM
    const fullTimeRegex = /^(\d{1,2}):(\d{2})$/;
    if (!fullTimeRegex.test(timeFrom) || !fullTimeRegex.test(timeTo)) {
      return null; // No validar si el formato no está completo
    }

    const fromMinutes = timeToMinutes(timeFrom);
    const toMinutes = timeToMinutes(timeTo);

    if (fromMinutes === null || toMinutes === null) return null;

    return toMinutes > fromMinutes;
  };

  // states for edit mode
  const [isEditing, setIsEditing] = useState(false);
  const [editingScheduleId, setEditingScheduleId] = useState(null);

  // states for delete confirmation modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [scheduleToDelete, setScheduleToDelete] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);

  // if no toggleForm provided, use internal state (for backward compatibility)
  const [internalShowForm, setInternalShowForm] = useState(false);
  const actualShowForm = showForm !== undefined ? showForm : internalShowForm;
  const actualToggleForm = toggleForm || (() => setInternalShowForm(!internalShowForm));

  const productCategoryTableHeaders = [
    "nameHeader",
    "franchiseLbl",
    "dayHeader",
    "timeRangeHeader",
    "actionsHeader",
  ];

  // function to convert days of the week (monday, tuesday, etc.) to chips
  const formatDays = (schedule) => {
    const dayMapping = {
      'monday': 'Lun',
      'tuesday': 'Mar',
      'wednesday': 'Mié',
      'thursday': 'Jue',
      'friday': 'Vie',
      'saturday': 'Sáb',
      'sunday': 'Dom'
    };
    
    const selectedDays = [];
    Object.keys(dayMapping).forEach((day) => {
      if (schedule[day] === 1) {
        selectedDays.push(dayMapping[day]);
      }
    });
    
    if (selectedDays.length === 0) {
      return <span style={{ color: '#999' }}>Ninguno</span>;
    }
    
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
        {selectedDays.map((day, index) => (
          <Chip
            key={index}
            label={day}
            size="small"
            style={{
              backgroundColor: '#E8F5E9',
              color: '#2b3233',
              fontSize: '12px',
              height: '24px',
              fontWeight: 500
            }}
          />
        ))}
      </div>
    );
  };

  // function to format the time range
  const formatTimeRange = (from, to) => {
    if (!from || !to) return 'N/A';
    // Convertir formato HH:MM:SS a HH:MM si es necesario
    const fromTime = from.substring(0, 5);
    const toTime = to.substring(0, 5);
    return `${fromTime} - ${toTime}`;
  };

  // function to format sale point names
  const formatSalePoints = (salePoints) => {
    if (!salePoints || salePoints.length === 0) return 'Ninguno';
    if (salePoints.length === 1) return salePoints[0].name;
    return salePoints.map(sp => sp.name).join(', ');
  };

  const createProductCategoryData = (schedule) => {
    return {
      name: schedule.shift_name,
      franchiseType: formatSalePoints(schedule.sale_points),
      days: formatDays(schedule),
      timeRange: formatTimeRange(schedule.available_from, schedule.available_to),
      actions: (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <img
            src={EditPrimaryIcon}
            alt="edit"
            onClick={(e) => {
              e.preventDefault();
              handleEditSchedule(schedule.id);
            }}
            style={{ cursor: "pointer" }}
          />
          <img
            src={DeleteIcon}
            alt="delete"
            onClick={(e) => {
              e.preventDefault();
              handleDeleteSchedule(schedule.id);
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    };
  };

  const goProductCategory = (id) => {
    localStorage.setItem("fk_product_category", id);
  };

  const handleDeleteSchedule = (id) => {
    setScheduleToDelete(id);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    if (!loadingDelete) {
      setOpenDeleteModal(false);
      setScheduleToDelete(null);
    }
  };

  const handleConfirmDelete = async () => {
    if (!scheduleToDelete) return;

    setLoadingDelete(true);
    try {
      // create FormData with the id of the schedule to delete
      const formData = new FormData();
      formData.append('availability_schedule_id', scheduleToDelete);
      
      // call the API to delete the schedule
      const response = await deleteScheduleProductAvailability(formData);
      
      if (response.error) {
        alert(`Error al eliminar el horario: ${response.error}`);
        return;
      }
      
      // reload data after deleting
      await fetchData(page, rowsPerPage, searchQuery);
      
      setOpenDeleteModal(false);
      setScheduleToDelete(null);
      
      // show success message
      setSnackbarMessage("Horario eliminado correctamente");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error al eliminar el horario:", error);
      alert("Error al eliminar el horario");
    } finally {
      setLoadingDelete(false);
    }
  };

  // function to load data for editing the schedule
  const handleEditSchedule = async (id) => {
    if (savingSchedule) {
      return;
    }

    
    try {
      setEditingScheduleId(id);
      setIsEditing(true);
      await new Promise(resolve => setTimeout(resolve, 10));
      if (toggleForm) {
        toggleForm();
      }

      if (!toggleForm || showForm === undefined) {
        setInternalShowForm(true);
      }
      

      let currentSalePoints = salePoints;
      if (currentSalePoints.length === 0) {
        const fkOrganization = localStorage.getItem("fk_organization");
        const response = await getAllSalePoint(fkOrganization);
        const formattedSalePoints = response.sale_points.map((point) => ({
          label: point.name,
          value: point.id,
          ...point,
        }));
        currentSalePoints = [
          { label: "Todos", value: "all", isAll: true },
          ...formattedSalePoints,
        ];
        setSalePoints(currentSalePoints);
      }

      // load schedule data from the new service
      const data = await getProductAvailabilitySchedule();
      const schedule = data.availability_schedules.find(s => s.id === id);

      if (!schedule) {
        alert("No se encontró el horario");
        return;
      }

      // pre-fill the form with the schedule data
      setScheduleName(schedule.shift_name || "");

      // map sale points
      if (schedule.sale_points && schedule.sale_points.length > 0) {
        const regularPoints = currentSalePoints.filter((point) => !point.isAll);
        const scheduleSalePoints = schedule.sale_points.map((salePoint) => {
          const found = regularPoints.find(
            (point) => point.value === salePoint.id || point.id === salePoint.id
          );
          return found || {
            label: salePoint.name,
            value: salePoint.id,
            id: salePoint.id,
          };
        });

        // if all points are selected, use the "All" option
        if (scheduleSalePoints.length === regularPoints.length && regularPoints.length > 0) {
          setSelectedSalePoints([{ label: "Todos", value: "all", isAll: true }, ...regularPoints]);
        } else {
          setSelectedSalePoints(scheduleSalePoints);
        }
      }

      // map schedules (available_from and available_to)
      if (schedule.available_from) {
        // convert format HH:MM:SS to HH:MM
        setTimeFrom(schedule.available_from.substring(0, 5));
      }
      if (schedule.available_to) {
        // convert format HH:MM:SS to HH:MM
        setTimeTo(schedule.available_to.substring(0, 5));
      }

      // map days of the week from the new format (monday, tuesday, etc.)
      const daysMap = {
        Lun: schedule.monday === 1,
        Mar: schedule.tuesday === 1,
        Mié: schedule.wednesday === 1,
        Jue: schedule.thursday === 1,
        Vie: schedule.friday === 1,
        Sáb: schedule.saturday === 1,
        Dom: schedule.sunday === 1,
      };

      setSelectedDays(daysMap);
      
    } catch (error) {
      console.error("Error al cargar el horario para editar:", error);
      alert("Error al cargar los datos del horario");
      setIsEditing(false);
      setEditingScheduleId(null);
    }
  };

  // ----------------------------------------------------
  // ------------------ Async calls ---------------------
  // ----------------------------------------------------
  const fetchData = async (page, rowsPerPage, searchQuery = null) => {
    setTableLoading(true)
    getProductAvailabilitySchedule().then((data) => {
      let productCategoryData = data.availability_schedules.map((schedule) =>
        createProductCategoryData(schedule)
      );
      
      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        productCategoryData = productCategoryData.filter((item) =>
          item.name.toLowerCase().includes(query) ||
          item.franchiseType.toLowerCase().includes(query) ||
          item.days.toLowerCase().includes(query)
        );
      }
      
      // do not apply pagination - show all results
      setProductCategories(productCategoryData);

      // disable pagination by passing page: -1
      let paginationObject = {
        page: -1,
        rowsPerPage: rowsPerPage,
        count: productCategoryData.length
      };
      setPagination(paginationObject);
      setLoading(false)
      setTableLoading(false)
    }).catch((error) => {
      console.error("Error fetching schedules:", error);
      setLoading(false);
      setLoadingError(true);
      setTableLoading(false);
    });
  };

  useEffect(() => {
    fetchData(page, rowsPerPage);
    fetchSalePoints();
  }, []);

  // function to fetch sale points
  const fetchSalePoints = async () => {
    try {
      const fkOrganization = localStorage.getItem("fk_organization");
      const response = await getAllSalePoint(fkOrganization);
      const formattedSalePoints = response.sale_points.map((point) => ({
        label: point.name,
        value: point.id,
        ...point,
      }));
      // add "All" option at the beginning of the list
      setSalePoints([
        { label: "Todos", value: "all", isAll: true },
        ...formattedSalePoints,
      ]);
    } catch (error) {
      console.error("Error fetching sale points:", error);
    }
  };

  useEffect(() => {
    if (actualShowForm && !isEditing && !editingScheduleId) {
      setScheduleName("");
      setSelectedSalePoints([]);
      setTimeFrom("");
      setTimeTo("");
      setSelectedDays({
        Lun: false,
        Mar: false,
        Mié: false,
        Jue: false,
        Vie: false,
        Sáb: false,
        Dom: false,
      });
    }
  }, [actualShowForm, isEditing, editingScheduleId]);
  
  // the form is opened when editing starts
  useEffect(() => {
    if (isEditing && editingScheduleId && !actualShowForm) {
      if (toggleForm) {
        toggleForm();
      } else {
        setInternalShowForm(true);
      }
    }
  }, [isEditing, editingScheduleId, actualShowForm, toggleForm]);
  
  useEffect(() => {
    if (!actualShowForm && !savingSchedule && editingScheduleId === null) {
      setIsEditing(false);
    }
  }, [actualShowForm, savingSchedule, editingScheduleId]);


  // ----------------------------------------------------
  // ------------------- Handlers -----------------------
  // ----------------------------------------------------
  const handleChangePage = async (newPage) => {
  };

  const handleChangeRowsPerPage = async (rowsPerPage) => {
  };

  const handleTextSearch = async (input) => {
    setSearchQuery(input)
    fetchData(0, rowsPerPage, input)
    setPage(0);
  };


  // function to format automatically the time input (HH:MM)
  const handleTimeInputChange = (timeField, value) => {
    // remove everything that is not a number or ":"
    let cleaned = value.replace(/[^\d:]/g, '');

    // if the user deletes everything, allow empty field
    if (cleaned === '') {
      if (timeField === 'from') {
        setTimeFrom('');
      } else {
        setTimeTo('');
      }
      return;
    }

    // if the user is writing numbers without ":", add ":" only when there are more than 2 digits
    if (!cleaned.includes(':')) {
      if (cleaned.length > 2) {
        // Si tiene más de 2 dígitos, agregar ":" después del segundo
        cleaned = cleaned.slice(0, 2) + ':' + cleaned.slice(2, 5);
      }
    }

    // validate format HH:MM
    const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const match = cleaned.match(timeRegex);

    if (match) {
      let hours = match[1] || '';
      let minutes = match[2] || '';

      // if it does not have ":" but has more than 2 digits, separate
      if (!cleaned.includes(':') && cleaned.length > 2) {
        hours = cleaned.slice(0, 2);
        minutes = cleaned.slice(2, 5);
      } else if (!cleaned.includes(':')) {
        hours = cleaned;
        minutes = '';
      }

      // validate hour range (0-23) and minutes (0-59)
      const hoursNum = hours ? parseInt(hours) : -1;
      const minutesNum = minutes ? parseInt(minutes) : -1;

      if ((hours === '' || (hoursNum >= 0 && hoursNum <= 23)) &&
        (minutes === '' || (minutesNum >= 0 && minutesNum <= 59))) {

        // do not format with padStart while the user is writing, only save the value
        let formatted = '';
        if (hours && minutes) {
          formatted = hours + ':' + minutes;
        } else if (hours && cleaned.includes(':')) {
          formatted = hours + ':';
        } else if (hours) {
          formatted = hours;
        } else {
          formatted = cleaned;
        }

        if (timeField === 'from') {
          setTimeFrom(formatted);
        } else {
          setTimeTo(formatted);
        }
      }
    }
  };

  // function to format the time when the field loses focus (onBlur)
  const handleTimeBlur = (timeField) => {
    const currentTime = timeField === 'from' ? timeFrom : timeTo;

    if (currentTime) {
      const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
      const match = currentTime.match(timeRegex);

      if (match) {
        let hours = match[1] || '00';
        let minutes = match[2] || '00';

        const hoursNum = parseInt(hours);
        const minutesNum = parseInt(minutes);

        if (hoursNum >= 0 && hoursNum <= 23 && minutesNum >= 0 && minutesNum <= 59) {
          const formatted = hours.padStart(2, '0') + ':' + minutes.padStart(2, '0');
          if (timeField === 'from') {
            setTimeFrom(formatted);
          } else {
            setTimeTo(formatted);
          }
        }
      }
    }
  };

  // handler for change in selection of sale points
  const handleSalePointsChange = (event, newValue, reason) => {
    const regularPoints = salePoints.filter((point) => !point.isAll);

    // check if the "All" option is selected
    const selectedAll = newValue.some((option) => option?.isAll);

    if (selectedAll) {
      // if "All" is selected, select all regular points
      setSelectedSalePoints(regularPoints);
    } else if (newValue.length === regularPoints.length && regularPoints.length > 0) {
      // if all points are selected manually, keep the selection
      setSelectedSalePoints(newValue);
    } else {
      // any other partial selection
      setSelectedSalePoints(newValue);
    }
  };

  const handleDayToggle = (day) => {
    setSelectedDays({
      ...selectedDays,
      [day]: !selectedDays[day],
    });
  };

  const handleAddSchedule = async () => {
    // validate form
    if (!scheduleName || !selectedSalePoints || selectedSalePoints.length === 0 || !timeFrom || !timeTo) {
      alert("Por favor complete todos los campos obligatorios");
      return;
    }

    const selectedDaysArray = Object.keys(selectedDays).filter(
      (day) => selectedDays[day]
    );

    if (selectedDaysArray.length === 0) {
      alert("Por favor seleccione al menos un día");
      return;
    }

    // get the IDs of the selected sale points
    const salePointIds = selectedSalePoints
      .filter((point) => !point.isAll)
      .map((point) => point.value || point.id);
    const allPointsSelected = selectedSalePoints.some((point) => point.isAll);

    if (isEditing && editingScheduleId) {
      const dayMapping = {
        'Lun': 'monday',
        'Mar': 'tuesday',
        'Mié': 'wednesday',
        'Jue': 'thursday',
        'Vie': 'friday',
        'Sáb': 'saturday',
        'Dom': 'sunday'
      };

      // create FormData with the required parameters
      const formData = new FormData();
      formData.append('availability_schedule_id', editingScheduleId);
      formData.append('shift_name', scheduleName);
      
      // add sale_point_ids as array JSON
      formData.append('sale_point_ids', JSON.stringify(salePointIds));
      
      formData.append('available_from', timeFrom);
      formData.append('available_to', timeTo);
      
      // add days of the week (0 or 1)
      Object.keys(dayMapping).forEach((spanishDay) => {
        const englishDay = dayMapping[spanishDay];
        formData.append(englishDay, selectedDays[spanishDay] ? '1' : '0');
      });

      try {
        setSavingSchedule(true);
        const response = await putScheduleProductAvailability(formData);
        
        if (response.error) {
          alert(`Error al actualizar el horario: ${response.error}`);
          setSavingSchedule(false);
          return;
        }

        // Reset
        setIsEditing(false);
        setEditingScheduleId(null);
        
        // reset form
        setScheduleName("");
        setSelectedSalePoints([]);
        setTimeFrom("");
        setTimeTo("");
        setSelectedDays({
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        });
        
        await new Promise(resolve => setTimeout(resolve, 50));
        
        if (actualToggleForm) {
          actualToggleForm();
        } else {
          setInternalShowForm(false);
        }
        
        // reload data after updating
        await fetchData(page, rowsPerPage, searchQuery);
        
        setSavingSchedule(false);
        
        // show success message
        setSnackbarMessage("Horario actualizado correctamente");
        setOpenSnackbar(true);
      } catch (error) {
        console.error("Error al actualizar el horario:", error);
        alert("Error al actualizar el horario. Por favor intente nuevamente.");
        setSavingSchedule(false);
      }
    } else {
      // creation mode 
      const dayMapping = {
        'Lun': 'monday',
        'Mar': 'tuesday',
        'Mié': 'wednesday',
        'Jue': 'thursday',
        'Vie': 'friday',
        'Sáb': 'saturday',
        'Dom': 'sunday'
      };

      const formData = new FormData();
      formData.append('shift_name', scheduleName);
      
      formData.append('sale_point_ids', JSON.stringify(salePointIds));
      
      formData.append('available_from', timeFrom);
      formData.append('available_to', timeTo);
      
      Object.keys(dayMapping).forEach((spanishDay) => {
        const englishDay = dayMapping[spanishDay];
        formData.append(englishDay, selectedDays[spanishDay] ? '1' : '0');
      });

      try {
        setSavingSchedule(true);
        const response = await postScheduleProductAvailability(formData);
        
        if (response.error) {
          alert(`Error al crear el horario: ${response.error}`);
          setSavingSchedule(false);
          return;
        }

        setIsEditing(false);
        setEditingScheduleId(null);
        
        // Reset
        setScheduleName("");
        setSelectedSalePoints([]);
        setTimeFrom("");
        setTimeTo("");
        setSelectedDays({
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        });
        
        await new Promise(resolve => setTimeout(resolve, 50));

        if (actualToggleForm) {
          actualToggleForm();
        } else {
          setInternalShowForm(false);
        }
        
        await fetchData(page, rowsPerPage, searchQuery);
        
        setSavingSchedule(false);

        setSnackbarMessage("Horario creado correctamente");
        setOpenSnackbar(true);
      } catch (error) {
        console.error("Error al crear el horario:", error);
        alert("Error al crear el horario. Por favor intente nuevamente.");
        setSavingSchedule(false);
      }
    }
  };

  // ----------------------------------------------------
  // -------------------- Render ------------------------
  // ----------------------------------------------------
  return (
    <>
      {loading && (
        <div className="d-flex justify-content-center spinner-container">
          <div className="spinner-border spinner-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {!loading &&
        <>
          {actualShowForm && (
            <>
              <div className="schedule-form-header">
                <AccessTimeIcon className="schedule-form-icon" />
                <h2 className="schedule-form-title">
                  {isEditing
                    ? "Editar horario de disponibilidad"
                    : "Configura los horarios de disponibilidad de productos"}
                </h2>
              </div>

              <div className="schedule-form-container">


                <div className="schedule-form-body">

                  {/* Nombre */}
                  <div className="schedule-form-field">
                    <label className="schedule-form-label">Nombre</label>
                    <TextField
                      variant="outlined"
                      className="schedule-input"
                      placeholder="Ej: Horario matutino"
                      value={scheduleName || ""}
                      onChange={(e) => setScheduleName(e.target.value)}
                    />
                  </div>

                  {/* Puntos de venta */}
                  <div className="schedule-form-field">
                    <label className="schedule-form-label">Puntos de venta</label>

                    <Autocomplete
                      multiple
                      options={salePoints}
                      getOptionLabel={(option) => option.label || option.name || ""}
                      value={selectedSalePoints}
                      onChange={handleSalePointsChange}
                      className="schedule-autocomplete"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Seleccione uno o más puntos de venta"
                          className="schedule-input"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            fontWeight: option.isAll ? "bold" : "normal",
                            backgroundColor: option.isAll ? "#E8F5E9" : "transparent",
                          }}
                        >
                          {option.label}
                        </li>
                      )}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                          const { key, ...tagProps } = getTagProps({ index });
                          return (
                            <Chip
                              key={key}
                              label={option.label}
                              {...tagProps}
                              style={{
                                backgroundColor: "#49a343",
                                color: "white",
                                margin: "2px 4px 2px 0",
                                borderRadius: "10px",

                              }}
                              onDelete={tagProps.onDelete}
                            />
                          );
                        })
                      }
                    />
                  </div>

                  {/* Horarios */}
                  <div className="schedule-time-range">
                    <div className="schedule-form-field small-field">
                      <label className="schedule-form-label">Desde (formato 24 horas)</label>
                      <TextField
                        variant="outlined"
                        className="schedule-input"
                        placeholder="HH:MM"
                        value={timeFrom || ""}
                        onChange={(e) => handleTimeInputChange("from", e.target.value)}
                        onBlur={() => handleTimeBlur("from")}
                        error={timeFrom && timeTo && !validateTimeRange(timeFrom, timeTo)}
                        helperText={
                          timeFrom && timeTo && !validateTimeRange(timeFrom, timeTo)
                            ? "La hora 'Desde' debe ser menor que 'Hasta'"
                            : ""
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccessTimeIcon style={{ color: '#9D9D9D', fontSize: '20px' }} />
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>

                    <div className="schedule-form-field small-field">
                      <label className="schedule-form-label">Hasta (formato 24 horas)</label>
                      <TextField
                        variant="outlined"
                        className="schedule-input"
                        placeholder="HH:MM"
                        value={timeTo || ""}
                        onChange={(e) => handleTimeInputChange("to", e.target.value)}
                        onBlur={() => handleTimeBlur("to")}
                        error={timeFrom && timeTo && !validateTimeRange(timeFrom, timeTo)}
                        helperText={
                          timeFrom && timeTo && !validateTimeRange(timeFrom, timeTo)
                            ? "La hora 'Hasta' debe ser mayor que 'Desde'"
                            : ""
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccessTimeIcon style={{ color: '#9D9D9D', fontSize: '20px' }} />
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>
                  </div>

                  {/* Días */}
                  <div className="schedule-form-field">
                    <label className="schedule-form-label">Días de la semana</label>
                    <div className="schedule-days-container">
                      {Object.keys(selectedDays).map((day) => (
                        <button
                          key={day}
                          type="button"
                          className={`schedule-day-button ${selectedDays[day] ? "selected" : ""}`}
                          onClick={() => handleDayToggle(day)}
                        >
                          {day}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Botón */}
                  <div className="schedule-form-actions">
                    <button
                      type="button"
                      className="btn btn-primary schedule-add-button"
                      onClick={handleAddSchedule}
                      disabled={savingSchedule}
                    >
                      {savingSchedule ? (
                        <>
                          <div className="spinner-border spinner-border-sm me-2" role="status">
                            <span className="visually-hidden">Cargando...</span>
                          </div>
                          Guardando...
                        </>
                      ) : (
                        <>
                          <AddIcon className="schedule-add-icon" />
                          {isEditing ? "Actualizar horario" : "Guardar horario"}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {tableLoading && <LinearProgress />}
          <div className="schedule-table-container">
            <CustomTable
              headers={productCategoryTableHeaders}
              rows={productCategories}
              pagination={pagination}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
          {loadingError && (<InternetErrorComponent></InternetErrorComponent>)}
          <Modal
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}
            aria-labelledby="modal-schedule-title"
            aria-describedby="modal-schedule-description"
          >
            <Box sx={modalStyle}>
              <Typography id="modal-schedule-title" variant="h6" component="h2" className="modal-title-confirm">
                Confirmar eliminación
              </Typography>
              <Typography id="modal-schedule-description" sx={{ mt: 2 }} className="modal-confirm-edit">
                ¿Está seguro de eliminar este horario?
              </Typography>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button 
                  onClick={handleCloseDeleteModal} 
                  variant="outlined"
                  disabled={loadingDelete}
                  sx={{
                    color: '#01A532',
                    borderColor: '#01A532',
                    backgroundColor: 'white',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    minWidth: '120px',
                    '&:hover': {
                      borderColor: '#01A532',
                      backgroundColor: '#01A532',
                      color: 'white',
                    },
                    '&:disabled': {
                      color: '#01A532',
                      borderColor: '#01A532',
                      opacity: 0.5,
                    },
                  }}
                >
                  CANCELAR
                </Button>
                <Button 
                  onClick={handleConfirmDelete} 
                  variant="contained" 
                  autoFocus
                  disabled={loadingDelete}
                  sx={{
                    backgroundColor: '#01A532',
                    color: 'white',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    minWidth: '120px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    '&:hover': {
                      backgroundColor: '#01A532',
                      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                    },
                    '&:disabled': {
                      backgroundColor: '#01A532',
                      opacity: 0.5,
                    },
                  }}
                >
                  SI, ELIMINAR
                </Button>
              </Box>
            </Box>
          </Modal>


          {/* Snackbar para mostrar mensajes de éxito/error */}
          <Snackbar
            open={openSnackbar}
            autoHideDuration={2000}
            onClose={() => setOpenSnackbar(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert 
              onClose={() => setOpenSnackbar(false)} 
              severity="success"
              sx={{ width: '100%' }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </>
      }

    </>
  );
};

export default ScheduleListPage;